export const MY_COMPANY_PROFILE_ID = 'myCompany';
export const HOME_ID = 'h-page';
